<template>
  <div class="mb-4 rounded bg-suc p-4 font-semibold text-suc-contrast">
    {{ $t('www.components.views.favorites.Success.text') }}
  </div>
</template>

<script setup lang="ts"></script>
